import {
  VEHICLEFUELSETTING_GET,
  VEHICLEFUELSETTING_POST,
  VEHICLEFUELSETTING_PUT,
  VEHICLEFUELSETTING_LOADING,
  VEHICLEFUELSETTING_ERROR,
  VEHICLEFUELSETTING_RESET,
} from '../../actions/types';

const initialState = {
  vehicleFuelSetting: null,
  isLoading: false,
  isCompleted: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case VEHICLEFUELSETTING_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case VEHICLEFUELSETTING_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    case VEHICLEFUELSETTING_GET:
      return { vehicleFuelSetting: action.payload, isLoading: false, isCompleted: true };
    case VEHICLEFUELSETTING_POST:
      return { vehicleFuelSetting: action.payload, isLoading: false, isCompleted: true };
    case VEHICLEFUELSETTING_PUT:
      return { vehicleFuelSetting: action.payload, isLoading: false, isCompleted: true };
    case VEHICLEFUELSETTING_RESET:
      return { vehicleFuelSetting: null, isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
